import { Injectable, signal } from '@angular/core';
import { NotificationService } from '../notification.service';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  constructor(private notificationService: NotificationService,) { }
  isOpen = signal<boolean>(false); // Signal-based state management

  toggle() {
    this.isOpen.update((state) => !state);
    // this.notificationService.showError('Please open');
  }
}